module.exports = __webpack_public_path__ + "static/media/pycharm.e3315438.webp";